import React from 'react'

interface SkeletonProps {
  width?: string
  height?: string
}

const Skeleton: React.FC<SkeletonProps> = ({ width = '100%', height = '16px' }) => {
  return (
    <div style={{
      width,
      height,
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
      backgroundSize: '200% 100%',
      animation: 'skeleton-loading 1.5s infinite',
      borderRadius: '4px',
      marginBottom: '12px'
    }} />
  )
}

const SkeletonLoader: React.FC = () => {
  return (
    <div style={{ padding: '20px' }}>
      <style>{`
        @keyframes skeleton-loading {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
      <Skeleton width="60%" height="24px" />
      <Skeleton width="100%" height="16px" />
      <Skeleton width="100%" height="16px" />
      <Skeleton width="80%" height="16px" />
      <div style={{ marginTop: '20px' }}>
        <Skeleton width="100%" height="200px" />
      </div>
    </div>
  )
}

export default SkeletonLoader
